import * as stylex from "@stylexjs/stylex";
import type { Ref } from "react";
import { copy } from "@/copy";
import "@/theme/tokens.stylex";
import { colors, motion, radii } from "@/theme/tokens.stylex";
import { press } from "@/ui/press";
type SidebarHandleProps = {
  shown: boolean;
  expanded: boolean;
  onOpen: () => void;
  ref?: Ref<HTMLButtonElement>;
};
const styles = {
  handle: {
    kVAEAm: "xixxii4",
    k87sOh: "xwa60dl",
    kbCHJM: "xddg5eg",
    kY2c9j: "xoegz02",
    kzqmXN: "x15yg21f",
    kZKoxP: "xjp8j0k",
    keoZOQ: "xrsdzbr",
    kmVPX3: "x1717udv",
    kMzoRj: "xc342km",
    kWkggS: "xjbqb8w",
    k1xSpc: "x78zum5",
    kGNEyG: "x6s0dn4",
    kjj79g: "xl56j7k",
    kkrTdU: "x1ypdohk",
    k1ekBW: "x6o7n8i",
    kIyJzY: "x2lra08",
    kAMwcw: "x1em5f5i",
    $$css: true
  },
  faded: {
    kSiTet: "xg01cxk",
    kfzvcC: "x47corl",
    $$css: true
  },
  off: {
    k1xSpc: "x1s85apg",
    $$css: true
  }
};
export function SidebarHandle({
  shown,
  expanded,
  onOpen,
  ref
}: SidebarHandleProps) {
  return <button ref={ref} type="button" hidden={!shown} inert={expanded} aria-label={copy.nav.expandMenu} aria-expanded={expanded} onClick={onOpen} {...stylex.props(styles.handle, press.scale, expanded && styles.faded, !shown && styles.off)}>
      <span className="x1lliihq x1ftt334 xy75621 xqhrb7l xrtxgzo" />
    </button>;
}